import { BCDivider } from '@bimser/components';
import { FormItemTypes, IDictionary } from '@bimser/core';
import { JSX } from 'react';
import { ICSSProperties, IPropertyField } from '../../../../entities/common';
import VisualControl from '../../base/VisualControl';
import { filterFields } from '../../helper';
import { IDividerProperties } from './entities/IDividerProperties';

const dividerStyle: ICSSProperties = { margin: 0 };
export default class Divider extends VisualControl {
	constructor() {
		super();
		this.controlType = FormItemTypes.EControlTypes.Divider;

		this.caption.visible = false;
	}

	__loadProperties(data: IDividerProperties) {
		super.__loadProperties(data);
	}

	__getPropertyFields(properties?: Map<string, any>): IPropertyField[] {
		const fields = super.__getPropertyFields();

		return [...filterFields(fields, ['enabled', 'clientEnabled'])];
	}

	__getComponentData(): IDictionary<any> {
		return {
			...super.__getComponentData()
		};
	}

	__render(children?: JSX.Element) {
		return super.__render(<BCDivider styles={{ ...dividerStyle, ...this.style }} />);
	}
}
